export const LS_AUTH_TOKEN = 'stucap-auth-token';
export const GRAPHQL_SERVER_URL = process.env.REACT_APP_GRAPHQL_SERVER_URL;
